//Model holding information needed to build a pass form
export class PassMetadata {
  constructor(park) {
    this.park = park;
    this.price = 0;
    this.sku = "";
    this.clin = "";
    this.rows = [];
  }

  addFields(fields) {
    if (!fields || fields.length === 0) {
      return;
    }

    fields.forEach(field => {
      this.addField(field);
    });
  }

  addField(field) {
    if (!this.rows[field.row - 1]) {
      let row = {
        id: field.row,
        fields: []
      };
      this.rows.push(row);
    }
    this.rows[field.row - 1].fields.push(field);
  }

  getField(name) {
    let foundField = null;
    this.rows.forEach(row => {
      let field = row.fields.find(n => {
        return n.name === name;
      });
      if (field) {
        foundField = field;
      }
    });
    return foundField;
  }

  getAllFields() {
    let fields = [];
    if (!this.rows) {
      return fields;
    }
    this.rows.forEach(row => {
      row.fields.forEach(field => {
        fields.push(field);
      });
    });
    return fields;
  }

  filterFieldsByCategory(category) {
    if (!category) {
      return;
    }
    this.rows.forEach(row => {
      row.fields = row.fields.filter(n => n.category === category);
    });
  }
}

export class PassMetadataField {}
